<template>
    <section class="my-3 cart-items row">
        <div class="col-12 col-lg-8 order-1 order-lg-0">

            <QuickAdd v-if="$page.props.auth.user.role == 'mtd'" :isWholesale="isWholesale" :update="update" />
            <div v-if="hasFutureItems">
                <p class="alert alert-warning">
                    There will be a cancellation fee of $50 for all future orders that are cancelled.
                </p>
            </div>
            <card v-if="shippedCartItems.length" icon="fas fa-box"
                :title="`${shippedCartItems.length} ${shippedCartItems.length > 1 ? 'items' : 'item'} ready to be shipped`">
                <template v-for="(item, itemIndex) in shippedCartItems" :key="item.id">
                    <ProductRow :item="item" :sku="item.product.sku"
                        :margin="`${itemIndex + 1 === shippedCartItems.length ? 'mb-0 pb-0 border-bottom-0' : 'mb-3'}`">

                        <template v-slot:headerContent>
                            <div class="col-4">
                                <div v-if="item.from_inventory" class="badge badge-success pt-1 ml-2 float-right">Item is on
                                    Truck</div>
                                <div v-if="!isWholesale && $page.props.auth.user.role == 'mtd' && !item.product.user_id">
                                    <div @click="changeToInventory(item)"
                                        class="badge badge-secondary pt-1 ml-2 mt-2 float-right cursor-pointer"
                                        v-if="!item.from_inventory"><i class="fas fa-truck mr-1 fa-sm"></i>Change to From
                                        Truck</div>
                                    <div @click="changeToShipping(item)"
                                        class="badge badge-secondary pt-1 ml-2 mt-2 float-right cursor-pointer" v-else><i
                                            class="fas fa-box mr-1 fa-sm"></i>Change to Shipping</div>
                                </div>
                            </div>
                        </template>

                        <div
                            class="d-flex flex-column flex-lg-row justify-content-between align-items-start align-items-lg-center">
                            <div>
                                <div class="d-flex flex-column flex-lg-row align-items-start align-items-lg-center"
                                    :class="{ 'mb-2': item.product.productPrice.isDiscounted }">
                                    <div class="mr-3 price-container">
                                        <PriceDisplay :product="item.product" :showEditPrice="userCanEditPrice(isWholesale)"
                                            :itemIndex="itemIndex" :cartItem="item" @onUpdate="update" />
                                    </div>
                                </div>

                                <Quantity class="mt-2 mt-lg-0" :item="item" :formDeleteItem="formDeleteItem"
                                    @quantityChanged="quantityChanged" @deleteItem="deleteItem"
                                    @increment="increaseQuantity" @decrement="decreaseQuantity" />

                                <p v-if="item.product.ship_flat_cost && isWholesale"
                                    class="mb-0 mt-1 text-secondary text-size-small">
                                    +${{ formatCurrency(item.product.ship_flat_cost * item.qty) }} Item Flat Shipping</p>
                                <p v-if="item.ship_flat_cost && !isWholesale"
                                    class="mb-0 mt-1 text-secondary text-size-small">+${{ formatCurrency(item.ship_flat_cost
                                        * item.qty) }} Item Flat Shipping</p>

                                <h5 class="mb-0 mt-3 font-weight-bold"
                                    :class="{ 'on-sale text-danger': item.product.productPrice.isDiscounted }">{{
                                        formatDollars(item.product.productPrice.price * item.qty) }}</h5>
                            </div>

                            <p @click="deleteItem(item)"
                                class="mb-0 text-danger text-size-small font-weight-bold cursor-pointer mt-2 mt-lg-0 d-flex align-items-center">
                                Remove Item <i class="fas fa-backspace ml-1"></i></p>
                        </div>
                    </ProductRow>
                </template>
            </card>
            <div v-if="this.$page.props.cartTotals?.subtotal" class="text-right">
                <p class="mb-0 text-right"><strong>Subtotal:</strong>
                    ${{ formatCurrency(this.$page.props.cartTotals.subtotal) }}</p>
            </div>

            <card v-if="backorderCartItems.length" title="These Items will be Placed on Backorder" class="mt-3">
                <template v-for="(item, itemIndex) in backorderCartItems" :key="item.id">
                    <ProductRow :item="item" :sku="item.product.sku"
                        :margin="`${itemIndex + 1 === backorderCartItems.length ? 'mb-0 pb-0 border-bottom-0' : 'mb-3'}`">
                        <template v-slot:headerContent>
                            <div class="col-4">
                                <p class="badge badge-primary pt-1 ml-2 float-right">
                                    <i class="fas fa-clock mr-1"></i>
                                    Expected to Ship: {{ getBackorderEta(item) }}
                                </p>
                            </div>
                        </template>

                        <div
                            class="d-flex flex-column flex-lg-row justify-content-between align-items-start align-items-lg-center">
                            <div>
                                <div class="d-flex flex-column flex-lg-row align-items-start align-items-lg-center">
                                    <div class="mr-3 price-container">
                                        <PriceDisplay :product="item.product" :showEditPrice="userCanEditPrice(isWholesale)"
                                            :itemIndex="itemIndex" :cartItem="item" @onUpdate="update" />
                                    </div>
                                </div>

                                <Quantity class="mt-2 mt-lg-0" :item="item" :formDeleteItem="formDeleteItem"
                                    @quantityChanged="quantityChanged" @deleteItem="deleteItem"
                                    @increment="increaseQuantity" @decrement="decreaseQuantity" />

                                <p v-if="item.product.ship_flat_cost && isWholesale"
                                    class="mb-0 mt-1 text-secondary text-size-small">
                                    +${{ formatCurrency(item.product.ship_flat_cost * item.qty) }} Item Flat Shipping</p>
                                <p v-if="item.ship_flat_cost && !isWholesale"
                                    class="mb-0 mt-1 text-secondary text-size-small">+${{ formatCurrency(item.ship_flat_cost
                                        * item.qty) }} Item Flat Shipping</p>

                                <h5 class="mb-0 mt-3 font-weight-bold"
                                    :class="{ 'on-sale text-danger': item.product.productPrice.isDiscounted }">{{
                                        formatDollars(item.product.productPrice.price * item.qty) }}</h5>
                            </div>

                            <p @click="deleteItem(item)"
                                class="mb-0 text-danger text-size-small font-weight-bold cursor-pointer mt-2 mt-lg-0 d-flex align-items-center">
                                Remove Item <i class="fas fa-backspace ml-1"></i></p>
                        </div>
                    </ProductRow>
                </template>
            </card>
            <div v-if="this.$page.props.cartTotals?.backorderSubtotal" class="text-right">
                <p class="mb-0 text-right"><strong>Backorder Subtotal:</strong>
                    ${{ formatCurrency(this.$page.props.cartTotals.backorderSubtotal) }}</p>
            </div>

            <card v-if="hasFutureItems" title="These items will be placed on a future order" class="mt-3">
                <template v-for="(item, itemIndex) in withFutureCartItems">
                    <ProductRow :item="item" :sku="item.product.sku"
                        :margin="`${itemIndex + 1 === withFutureCartItems.length ? 'mb-0 pb-0 border-bottom-0' : 'mb-3'}`"
                        v-if="item.future_items.length" class="future_items">
                        <div class="d-flex flex-column cart-future-item">
                            <div v-for="futureItem in item.future_items" class="mb-3 future_items">
                                <div class="d-flex align-items-center">
                                    <Calendar class="w-100 form-control-sm px-0 mr-1 h-100"
                                        style="min-width: 120px;max-width: 125px;" showButtonBar showIcon
                                        inputClass="w-100 small" dateFormat="mm/dd/yy"
                                        v-model="futureItem.order_future_date" :minDate="minFutureDate"
                                        :maxDate="maxFutureDate"
                                        @update:modelValue="() => futureItemChanged(item, futureItem)" />
                                    <Quantity class="mt-lg-0" :item="Object.assign({}, item, futureItem, { id: item.id })"
                                        :formDeleteItem="formDeleteItem" @quantityChanged="quantityChanged"
                                        @deleteItem="deleteItem" @increment="increaseQuantity"
                                        @decrement="decreaseQuantity" />
                                    <div class="d-none d-lg-block ml-auto">
                                        <p @click="() => deleteItem(Object.assign({}, item, futureItem, { id: item.id }))"
                                            class="text-danger text-size-small font-weight-bold cursor-pointer d-flex align-items-center mb-0">
                                            Remove Item <i class="fas fa-backspace ml-1"></i></p>
                                    </div>
                                </div>
                                <div class="d-flex align-items-center justify-content-between mt-1 ">
                                    <h5 class="font-weight-bold mb-0">{{ formatDollars((item.productPrice.price) *
                                        futureItem.qty) }}</h5>
                                    <div class="d-block d-lg-none float-right">
                                        <p @click="() => deleteItem(Object.assign({}, item, futureItem, { id: item.id }))"
                                            class="text-danger text-size-small font-weight-bold cursor-pointer d-flex align-items-center mb-0">
                                            Remove Item <i class="fas fa-backspace ml-1"></i></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ProductRow>
                </template>
            </card>
            <div v-if="this.$page.props.cartTotals?.futureSubtotal" class="text-right">
                <p class="mb-0 text-right"><strong>Future Subtotal:</strong>
                    ${{ formatCurrency(this.$page.props.cartTotals.futureSubtotal) }}</p>
            </div>
        </div>

        <div class="col-12 col-lg-4">
            <card class="mb-3">
                <p class="mb-0"><strong>Subtotal:</strong> {{ formatDollars($page.props.cart_total) }}</p>

                <div class="mt-2">
                    <jet-button class="btn-sm mr-3 my-1 m-w-100" icon="fas fa-times-circle" @click="clearCart">Clear
                        Cart</jet-button>

                    <jet-button v-if="isMtd() && !isWholesale" class="btn-sm m-w-100 my-1"
                        :goesTo="route('mtd.cart.convert')" icon="fas fa-share">Copy Items to Wholesale Cart</jet-button>
                </div>
            </card>

            <slot></slot>

        </div>
    </section>
</template>

<script>
import Quantity from '@/Shared/Quantity'
import ProductRow from '@/Components/Shop/ProductRow'
import PriceDisplay from '@/Components/Shop/PriceDisplay'

import QuickAdd from '@/Components/Shop/QuickAdd'
import Calendar from 'primevue/calendar'

export default {
    components: {
        Quantity,
        ProductRow,
        PriceDisplay,
        QuickAdd,
        Calendar
    },
    data() {
        return {
            itemForm: this.$inertia.form({
                order_future_date: null,
                item_id: null
            }),
            formUpdateQuantity: this.$inertia.form({
                item_id: null,
                qty: null
            }),
            formUpdateProduct: this.$inertia.form({
                order_future_date: null,
                cart_item_future_id: null,
                item_id: null
            }),
            formDeleteItem: this.$inertia.form({
                order_future_date: null,
                item_id: null
            }),
            minFutureDate: new Date(moment()),
            maxFutureDate: new Date(moment().add(8, 'month')),
        }
    },
    props: {
        cart_items: Array,
        users: Array,
        total: Number,
        cartSent: Boolean,
        isWholesale: {
            type: Boolean,
            default: false
        },
    },
    computed: {
        hasFutureItems() {
            return this.cart_items.some(item => item.future_items.length > 0);
        },
        withFutureCartItems() {
            this.cart_items.forEach(item => {
                item.future_items.forEach(futureItem => {
                    futureItem.order_future_date = futureItem.order_future_date ? new Date(futureItem.order_future_date) : futureItem.order_future_date
                })
            })
            return this.cart_items
        },
        shippedCartItems() {
            return this.cart_items.filter(item => {
                const fromTruck = !this.isWholesale && item.from_inventory
                return (!item.show_as_backorder || fromTruck) && item.qty > 0
            })
        },
        backorderCartItems() {
            return this.cart_items.filter(item => {
                const fromTruck = !this.isWholesale && !item.from_inventory

                return (this.isWholesale ? item.show_as_backorder : item.show_as_backorder && fromTruck) && item.qty > 0
            })
        }
    },
    methods: {
        update() {
            this.$inertia.reload();
        },
        clearCart() {
            this.$inertia.visit(route(this.isWholesale ? 'mtd.cart.clear' : 'cart.clear'));
        },
        hideCartPrompt() {
            $('#cartSendPromptModal').modal('hide');
        },
        getBackorderEta(item) {
            if (item.backorder_eta % 7 === 0)
                return item.backorder_eta / 7 + ' weeks'
            else
                return item.backorder_eta + ' days'
        },
        deleteItem(item) {
            if (this.itemForm.processing) return;

            this.itemForm.order_future_date = item.order_future_date
            this.itemForm.item_id = item.id;

            this.itemForm.post(this.route(this.isWholesale ? 'mtd.cart.deleteItem' : 'cart.deleteItem'), {
                preserveScroll: true,
                onSuccess: () => {
                    this.trackRemoveFromCart({
                        id: item.product.id,
                        name: item.product.name,
                        price: item.price,
                    }, item.qty, this.$page.props);
                },
            });
        },
        saveItem(item) {
            this.formUpdateQuantity.order_future_date = item.order_future_date
            this.formUpdateQuantity.cart_item_future_id = item.cart_item_future_id
            this.formUpdateQuantity.item_id = item.id
            this.formUpdateQuantity.qty = item.qty

            this.formUpdateQuantity.post(this.route(this.isWholesale ? 'mtd.cart.updateItem' : 'cart.updateItem'), {
                preserveScroll: true,
                onSuccess: () => {
                    this.trackCartQuantityUpdate({
                        id: item.product.id,
                        name: item.product.name,
                        price: item.price,
                    }, item.linked_qty, item.qty, this.$page.props);
                },
            })
        },
        updateQuantity(e, item) {
            item.qty = e.target.value
        },
        futureItemChanged(item, futureItem) {
            const updateItem = Object.assign({}, item, futureItem, { id: item.id, cart_item_future_id: futureItem.id })
            this.saveItem(updateItem)
        },
        quantityChanged($event, item) {
            this.updateQuantity($event, item)
            this.saveItem(item)
        },
        increaseQuantity(item) {
            item.qty++
            this.saveItem(item)
        },
        decreaseQuantity(item) {
            if (item.qty > 0) {
                item.qty--
                this.saveItem(item)
            }
        },
        toggleOverlay(event, id) {
            this.$refs[`cart-image-overlay${id}`].toggle(event)
        },
        changeToInventory(item) {
            if (item.from_inventory || this.formUpdateProduct.processing) return;

            this.formUpdateProduct.item_id = item.id;
            this.formUpdateProduct.post(this.route('mtd.cart.changeToInventory'), {
                preserveScroll: true
            })
        },
        changeToShipping(item) {
            if (!item.from_inventory || this.formUpdateProduct.processing) return;

            this.formUpdateProduct.item_id = item.id;
            this.formUpdateProduct.post(this.route('mtd.cart.changeToShipping'), {
                preserveScroll: true
            })
        }
    }
}
</script>

<style>
.discount-container.applied {
    margin-top: 21px;
}

@media (max-width: 992px) {
    .discount-container.applied {
        margin-top: 7.5px;
    }
}
</style>

<style lang="scss">
.cart-future-item .p-calendar .p-datepicker-trigger {
    height: 25px;
}

.product-col.future_items .slot-container {
    width: 100% !important;
}

.cart-future-item .p-calendar .p-inputtext {
    height: 25px;
}
</style>
